<script>
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

export let data;
export let digits = 0;

let showRange = false;
let el;
let inst;

function average(list){
    if(!list || list.length == 0) return 0;
    let avg = (list.reduce((a,c) => a+c, 0)) / list.length;
    if(Number.isNaN(avg)) return 'N/A';
    return avg.toFixed(digits);
}

function range(list){
    if(!list || list.length == 0) return '';
    return `${Math.min(...list).toFixed(1)}-${Math.max(...list).toFixed(1)}`;
}

// A 40-bin distribution strip with the mean marked. Built as an SVG string only when the
// tooltip is first opened, so a page full of these costs nothing until one is hovered.
function sparkline(list){
    let w = 150, h = 34, bins = 40;
    let lo = Math.min(...list);
    let hi = Math.max(...list);
    if(!(hi > lo)) return `<div style="font:11px ui-monospace,monospace;opacity:0.7">all ${lo.toFixed(digits)}</div>`;
    let counts = new Array(bins).fill(0);
    for(let v of list){
        let i = Math.floor((v - lo) / (hi - lo) * bins);
        counts[i >= bins ? bins - 1 : i < 0 ? 0 : i]++;
    }
    let peak = Math.max(...counts);
    let bw = w / bins;
    let rects = counts.map((c, i) => {
        let bh = c / peak * h;
        return `<rect x="${(i * bw).toFixed(1)}" y="${(h - bh).toFixed(1)}" width="${Math.max(1, bw - 0.6).toFixed(1)}" height="${bh.toFixed(1)}" fill="#4bb8ae"/>`;
    }).join('');
    let mean = list.reduce((a, c) => a + c, 0) / list.length;
    let mx = ((mean - lo) / (hi - lo) * w).toFixed(1);
    return `<svg width="${w}" height="${h}" viewBox="0 0 ${w} ${h}" style="display:block">${rects}` +
        `<line x1="${mx}" y1="0" x2="${mx}" y2="${h}" stroke="#d9a441" stroke-width="1.5"/></svg>`;
}

function tipContent(list){
    if(!list || list.length == 0) return 'No data';
    let sorted = [...list].sort((a, b) => a - b);
    let m = Math.floor(sorted.length / 2);
    let med = sorted.length % 2 ? sorted[m] : (sorted[m - 1] + sorted[m]) / 2;
    let mono = 'font:11px ui-monospace,SFMono-Regular,Menlo,monospace;';
    return `<div style="${mono}display:grid;gap:4px">` +
        sparkline(list) +
        `<div style="display:flex;gap:10px;opacity:0.85">` +
            `<span>n ${list.length.toLocaleString()}</span>` +
            `<span>med ${med.toFixed(digits)}</span>` +
            `<span>${sorted[0].toFixed(digits)}–${sorted[sorted.length - 1].toFixed(digits)}</span>` +
        `</div></div>`;
}

// Created on first hover rather than on mount: there can be hundreds of these on screen.
function ensureTip(){
    if(inst || !el || !data || data.length == 0) return;
    inst = tippy(el, {
        content: tipContent(data),
        allowHTML: true,
        showOnCreate: true,
        appendTo: () => document.body,
        maxWidth: 200
    });
}

// If the numbers change after a tooltip exists, refresh its contents.
$: if(inst && data) inst.setContent(tipContent(data));
</script>

<span bind:this={el}
      style="cursor: pointer;"
      on:mouseenter={ensureTip}
      on:focus={ensureTip}
      tabindex="0"
      role="button"
      aria-label="Toggle between average and range"
      on:keydown={e => { if(e.key == 'Enter' || e.key == ' '){ e.preventDefault(); showRange = !showRange; } }}
      on:click={e => { showRange = !showRange; }}>{(showRange ? range(data) : average(data))}</span>

<style>

</style>
